function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
      <g fill="currentColor">
        <circle r="3" cx="11" cy="3" />
        <circle r="3" cx="11" cy="11" />
        <circle r="3" cx="11" cy="19" />
      </g>
    </svg>
  );
}

export default Icon;
